import React, { useEffect, useState } from "react";
import LoadingPage from "../Loading/loading";
import { useNavigate } from "react-router-dom";
import { Cookies } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";
import { createAction } from "../../network/api/actions";

const AddActionPage = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState();

  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  const handleChange = (e) => {
    e.target.setCustomValidity("");
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    createAction({
      name: formData.name,
      description: formData.description,
    }).then((result) => {
      if (result.data.message === "Created successfully") {
        toast.success(result.data.message, {
          position: "top-right",
        });
        props.changeToView("View Actions");
      } else {
        toast.error(result.data.message, {
          position: "top-right",
        });
      }
      setLoading(false);
    });
  };

  return (
    <div className="add-brokers-guideline">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="Name">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter Name"
            required
            onInvalid={(e) => e.target.setCustomValidity("Name is required")}
          />
        </div>

        <div className="form-group">
          <label htmlFor="region">Type</label>
          <select
            className="form-select form-control form-select-lg border border-dark"
            aria-label="Select Type"
            name="description" // Changed from type2 to be more descriptive
            value={formData.description}
            onChange={(e) => {
              e.target.setCustomValidity("");
              setFormData({
                ...formData,
                description: e.target.value,
              });
            }}
            style={{
              width: "100%",
              padding: "10px",
              border: "1px solid #ddd",
              borderRadius: "6px",
              fontSize: "16px",
              backgroundColor: "#fff",
              cursor: "pointer",
            }}
            required
            onInvalid={(e) =>
              e.target.setCustomValidity("Description is required")
            }
          >
            <option disabled value="">
              Select Type
            </option>
            <option>Follow</option>
            <option>No Follow</option>
            <option>Done</option>
          </select>
        </div>

        {loading ? (
          <div
            style={{
              width: "100%",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <div className="spinner"></div>
          </div>
        ) : (
          <button type="submit" className="submit-button">
            Add Action
          </button>
        )}
      </form>
      <ToastContainer />
    </div>
  );
};

export default AddActionPage;
